

// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { IoCloseCircleOutline } from 'react-icons/io5';
// import QRCode from 'react-qr-code';
// import axios from 'axios';

// const HostLiveRoom = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   // const { pin, eventId, joinUrl, certMode, userId } = location.state || {};

//   // Operational state vectors
//   const [gameState, setGameState] = useState({ game_stage: 'lobby', current_question_index: 0, seconds_left: 0 });
//   const [questions, setQuestions] = useState([]);
//   const [connectedPlayers, setConnectedPlayers] = useState([]);

// // Local state vectors for custom game rules configuration
//   const [customDuration, setCustomDuration] = useState(30); // Default fallback: 30 seconds
//   const [customMarks, setCustomMarks] = useState(10);       // Default fallback: 10 marks per question
// // Operational state for final match standings
//   const [leaderboard, setLeaderboard] = useState([]);

// const params = useParams();


// const pin = location.state?.pin || params?.roomPin;
//   const eventId = location.state?.eventId || null;
//   const userId = location.state?.userId || null;
//   const certMode = location.state?.certMode || false;

//   // Auto-generate joinUrl if not passed from caller
//   const joinUrl = location.state?.joinUrl || `${window.location.origin}/join?pin=${pin}${eventId ? `&eventId=${eventId}` : ''}`;


// // Guard flag to prevent duplicate automatic triggers
// const isAutoAdvancing = React.useRef(false);

//   const colors = {
//     orange: '#f35018',
//     blue: '#2f3194',
//     cyan: '#63decc',
//     textMain: '#0f1137'
//   };

//   const premiumColors = ['#e21b3c', '#1368ce', '#d89e00', '#26890c'];

//   // Redirect host safely back if fundamental state metrics are missing
// useEffect(() => {
//     if (!pin) {
//       alert("Invalid room parameters detected.");
//       navigate('/Dashboard/45g676tr/Dashboard');
//     }
//   }, [pin, navigate]);

//   // Integrated master synchronization engine loop (Polled every 1 second)
//   useEffect(() => {
//     if (!pin || !eventId) return;

//     // Fetch base quiz questions array template once
//     axios.get(`https://rvapi.emedha.in/pages/api/api/questions?eventId=${eventId}`)
//       .then(res => setQuestions(res.data))
//       .catch(err => console.error("Error loading questionnaire stream:", err));

// const syncEngine = async () => {
//       try {
//         const stateRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${pin}`);
//         setGameState(stateRes.data);

//         // Fetch user profiles while waiting in the lobby layer stage
//         if (stateRes.data.game_stage === 'lobby' || stateRes.data.game_stage === 'scheduled') {
//           const playersRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/live-lobby-players/${pin}`);
//           if (Array.isArray(playersRes.data)) {
//             setConnectedPlayers(playersRes.data);
//           }
//         }

//         // NEW: Fetch match ranking array metrics if the game hits the podium stage
//   // NEW: Fetch aggregated match ranking array metrics if the game hits the podium stage
//         if (stateRes.data.game_stage === 'podium') {
//           const rankRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/podium-standings/${pin}`);
//           if (Array.isArray(rankRes.data)) {
//             // No sorting fallback needed since the SQL query returns rows already ordered by total DESC
//             setLeaderboard(rankRes.data);
//           }
//         }
//       } catch (err) {
//         console.error("Lobby sync framework tracking error:", err);
//       }
//     };

//   const initialDelayTimeout = setTimeout(() => {
//       syncEngine();
//     }, 500);

//     const intervalId = setInterval(syncEngine, 1000);

//     return () => {
//       clearTimeout(initialDelayTimeout);
//       clearInterval(intervalId);
//     };
//   }, [pin, eventId]);

//   // Automatic Stage Transition Engine when timer expires
// useEffect(() => {
//   if (!pin || isAutoAdvancing.current) return;

//   // 1. When the question timer expires -> Auto-transition to 'reveal'
//   if (gameState.game_stage === 'question' && gameState.seconds_left <= 0 && questions.length > 0) {
//     isAutoAdvancing.current = true;

//     axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', {
//       roomPin: pin,
//       nextStage: 'reveal',
//       nextIndex: gameState.current_question_index,
//       duration: 0,
//       questionMarks: customMarks,
//     })
//     .catch((err) => console.error("Auto reveal failed:", err))
//     .finally(() => {
//       // Release lock after state syncs
//       setTimeout(() => { isAutoAdvancing.current = false; }, 1200);
//     });
//   }

//   // 2. When on 'reveal' -> Display answer for 4 seconds, then auto-advance to next question or podium
//   if (gameState.game_stage === 'reveal' && questions.length > 0) {
//     const revealTimer = setTimeout(async () => {
//       if (isAutoAdvancing.current) return;
//       isAutoAdvancing.current = true;

//       const nextIndex = gameState.current_question_index + 1;
//       const isMatchFinished = nextIndex >= questions.length;

//       try {
//         await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', {
//           roomPin: pin,
//           nextStage: isMatchFinished ? 'podium' : 'question',
//           nextIndex: isMatchFinished ? 0 : nextIndex,
//           duration: isMatchFinished ? 0 : customDuration,
//           questionMarks: isMatchFinished ? 0 : customMarks,
//         });

//         if (isMatchFinished) {
//         axios.post('https://rvapi.emedha.in/pages/api/api/quiz/finish-session', {
//           roomPin: pin,
//           eventId: eventId
//         }).catch(e => console.error("Error finalizing session:", e));
//       }

//       } catch (err) {
//         console.error("Auto next question failed:", err);
//       } finally {
//         setTimeout(() => { isAutoAdvancing.current = false; }, 1200);
//       }
//     }, 4000); // 4-second review window

//     return () => clearTimeout(revealTimer);
//   }
// }, [gameState.game_stage, gameState.seconds_left, gameState.current_question_index, pin, questions.length, customDuration, customMarks]);

//   // const handleStartGame = async () => {
//   //   try {
//   //     await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/start-game', { 
//   //       roomPin: pin, 
//   //       totalDuration: customDuration,
//   //       questionMarks: customMarks
//   //     });
//   //   } catch (err) {
//   //     console.error("Failed to accelerate game state stage:", err);
//   //   }
//   // };

//   // const handleNextAction = async () => {
//   //   const isReveal = gameState.game_stage === 'question';
//   //   const nextStage = isReveal ? 'reveal' : 'question';
//   //   const nextIndex = isReveal ? gameState.current_question_index : gameState.current_question_index + 1;

//   //   if (!isReveal && nextIndex >= questions.length) {
//   //     await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', { 
//   //       roomPin: pin, 
//   //       nextStage: 'podium', 
//   //       nextIndex: 0, 

//   //       duration: 0,
//   //       questionMarks: 0
//   //     });
//   //     return;
//   //   }

//   //   await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', {
//   //     roomPin: pin,
//   //     nextStage,
//   //     nextIndex,

//   //     duration: isReveal ? 0 : customDuration, // Dynamic duration injection
//   //     questionMarks: customMarks
//   //   });
//   // };


//   const handleStartGame = async () => {
//     try {
//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/start-game', { 
//         roomPin: pin, 
//         totalDuration: customDuration,
//         questionMarks: customMarks
//       });
//       // Ensure backend session table tracks active state
//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', {
//         roomPin: pin,
//         nextStage: 'question',
//         nextIndex: 0,
//         duration: customDuration,
//         questionMarks: customMarks
//       });
//     } catch (err) {
//       console.error("Failed to accelerate game state stage:", err);
//     }
//   };

// const handleNextAction = async () => {
//     if (isAutoAdvancing.current) return;
//     isAutoAdvancing.current = true;

//     const isReveal = gameState.game_stage === 'question';
//     const nextStage = isReveal ? 'reveal' : 'question';
//     const nextIndex = isReveal ? gameState.current_question_index : gameState.current_question_index + 1;

//     try {
//       if (!isReveal && nextIndex >= questions.length) {
//         await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', { 
//           roomPin: pin, 
//           nextStage: 'podium', 
//           nextIndex: 0, 
//           duration: 0,
//           questionMarks: 0
//         });
//         return;
//       }

//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/advance-stage', {
//         roomPin: pin,
//         nextStage,
//         nextIndex,
//         duration: isReveal ? 0 : customDuration,
//         questionMarks: customMarks
//       });
//     } catch (err) {
//       console.error("Manual skip error:", err);
//     } finally {
//       setTimeout(() => { isAutoAdvancing.current = false; }, 800);
//     }
//   };

//   // const handleCloseRoomScrub = async () => {
//   //   const confirmation = window.confirm("Are you sure you want to close this room? All participants will be disconnected.");
//   //   if (!confirmation) return;

//   //   try {
//   //     await axios.delete(`https://rvapi.emedha.in/pages/api/api/quiz/close-session/${pin}`);
//   //     navigate(-1);
//   //   } catch (error) {
//   //     console.error("Error scrubbing room session profile:", error);
//   //     navigate(-1);
//   //   }
//   // };


// const handleCloseRoomScrub = async () => {
//     const confirmation = window.confirm("Are you sure you want to exit? If the match is not complete, it will be marked as abandoned.");
//     if (!confirmation) return;

//     try {
//       if (gameState.game_stage !== 'podium') {
//         // Abandon active game
//         await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/abandon-session', { roomPin: pin });
//       } else {
//         // Finalize completed match
//         await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/finish-session', { roomPin: pin, eventId });
//       }
//       navigate(-1);
//     } catch (error) {
//       console.error("Error ending session:", error);
//       navigate(-1);
//     }
//   };


//   const currentQuestion = questions[gameState.current_question_index];

//   return (
//     <div style={{ 
//       background: 'radial-gradient(circle at top right, #1e1f4b 0%, #0b0c26 100%)', 
//       fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
//       minHeight: '100vh',
//       color: '#ffffff',
//       padding: '40px 20px'
//     }}>
      
//       {/* Top Header Management Bar */}
//       <div className="d-flex justify-content-between align-items-center mb-5 max-width-xl mx-auto px-4">
//         <div>
//           <span style={{ color: colors.cyan, fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase' }}>
//             Live Match Lobby — Stage: {gameState.game_stage}
//           </span>
//           <h1 className="m-0 fw-bold" style={{ fontSize: '24px', letterSpacing: '-0.5px' }}>
//             Quizify<span style={{ color: colors.orange }}>AI</span> Live
//           </h1>
//         </div>
//         <button 
//           onClick={handleCloseRoomScrub} 
//           className="btn d-flex align-items-center gap-2 px-3 py-2"
//           style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: '#ff6b6b', borderRadius: '12px', fontSize: '13px' }}
//         >
//           <IoCloseCircleOutline size={18} /> Close Room
//         </button>
//       </div>

//       {/* Primary Context Router Stage Wrapper */}
//       <div className="container-xl">
        
//         {/* LOBBY INTERFACE STAGE DISPLAY */}
//         {(gameState.game_stage === 'lobby' || gameState.game_stage === 'scheduled') && (
//           <div>
//             {gameState.game_stage === 'scheduled' && (
//       <div className="alert alert-warning text-center mx-auto mb-4 py-2" style={{ maxWidth: '600px', borderRadius: '12px', fontWeight: '600' }}>
//         📅 Scheduled Session — Click "Start Live Match" when you are ready to open the room to live questions!
//       </div>
//     )}

//             <div className="row g-4 align-items-center justify-content-center">
//               {/* Left Block: 6-Digit PIN Display Block */}
//               <div className="col-12 col-md-6 col-lg-5 text-center text-md-start">
//                 <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', padding: '40px', borderRadius: '28px', backdropFilter: 'blur(10px)' }}>
//                   <p className="text-muted mb-2 fw-semibold" style={{ fontSize: '13px', letterSpacing: '1px' }}>JOINING DIRECTIONS</p>
//                   <h2 className="mb-4" style={{ fontSize: '20px', fontWeight: '500', lineHeight: '1.4' }}>
//                     Open the portal page and input the authorization sequence code:
//                   </h2>
                  
//                   <div style={{ 
//                     background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)',
//                     border: `1px solid rgba(99, 222, 204, 0.25)`,
//                     padding: '20px 40px',
//                     borderRadius: '20px',
//                     display: 'inline-block',
//                     fontSize: '48px',
//                     fontWeight: '800',
//                     color: colors.cyan,
//                     letterSpacing: '4px',
//                     boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
//                   }}>
//                     {pin}
//                   </div>

//                   <div className="mt-4">
//                     <small className="text-muted d-block mb-1">DIRECT LINK INSTANCE</small>
//                     <code style={{ color: colors.cyan, fontSize: '12px', wordBreak: 'break-all' }}>{joinUrl}</code>
//                   </div>
//                 </div>
//               </div>

//               {/* Right Block: Dynamic Embedded QR Code Canvas */}
//               <div className="col-12 col-md-5 col-lg-4 text-center">
//                 <div style={{ background: '#ffffff', padding: '30px', borderRadius: '28px', display: 'inline-block', boxShadow: '0 30px 60px rgba(0,0,0,0.4)' }}>
//                   <div style={{ background: '#ffffff', padding: '15px', borderRadius: '16px', border: '1px solid #f0f0f0' }}>
//                     {joinUrl && (
//                       <QRCode 
//                         value={joinUrl}
//                         size={220}
//                         style={{ height: "auto", maxWidth: "100%", width: "100%" }}
//                         viewBox={`0 0 250 250`}
//                       />
//                     )}
//                   </div>
//                   <p className="mb-0 mt-3 fw-bold" style={{ color: colors.blue, fontSize: '13px', letterSpacing: '0.3px' }}>
//                     📷 SCAN QR TO JOIN GAME
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Waiting Room Lobby Footer Layout */}
//             {/* <div className="mt-5 max-width-xl mx-auto px-3">
//               <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-secondary pb-2" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
//                 <h4 className="fw-bold m-0" style={{ fontSize: '16px', color: '#fff' }}>
//                   Waiting Room Lobby ({connectedPlayers.length} players joined)
//                 </h4>
//                 <button 
//                   onClick={handleStartGame}
//                   className="btn fw-bold px-4 py-2" 
//                   style={{ background: `linear-gradient(135deg, ${colors.cyan}, #40bda9)`, color: colors.blue, borderRadius: '12px', border: 'none', fontSize: '13px' }}
//                 >
//                   Start Live Match
//                 </button>
//               </div>
//               {/* Waiting Room Lobby Footer Layout */}
//             <div className="mt-5 max-width-xl mx-auto px-3">
              
//               {/* NEW: Game Rules Configuration Control Inputs Panel */}
//               <div className="row g-3 mb-4 p-4 rounded-4 justify-content-center align-items-center" style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
//                 <div className="col-12 col-sm-5 col-md-4">
//                   <label className="form-label small fw-bold tracking-wide text-uppercase" style={{ color: colors.cyan }}>⏱️ Question Timer (Seconds)</label>
//                   <input 
//                     type="number" 
//                     className="form-control text-center text-white fw-bold" 
//                     style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(99,222,204,0.2)', borderRadius: '10px' }}
//                     min={5} 
//                     max={120} 
//                     value={customDuration} 
//                     onChange={(e) => setCustomDuration(parseInt(e.target.value) || 0)} 
//                   />
//                 </div>
//                 <div className="col-12 col-sm-5 col-md-4">
//                   <label className="form-label small fw-bold tracking-wide text-uppercase" style={{ color: colors.cyan }}>🎯 Points / Marks Per Question</label>
//                   <input 
//                     type="number" 
//                     className="form-control text-center text-white fw-bold" 
//                     style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(99,222,204,0.2)', borderRadius: '10px' }}
//                     min={1} 
//                     max={1000} 
//                     value={customMarks} 
//                     onChange={(e) => setCustomMarks(parseInt(e.target.value) || 0)} 
//                   />
//                 </div>
//               </div>

//               <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-secondary pb-2" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
//                 <h4 className="fw-bold m-0" style={{ fontSize: '16px', color: '#fff' }}>
//                   Waiting Room Lobby ({connectedPlayers.length} players joined)
//                 </h4>
//                 <button 
//                   onClick={handleStartGame}
//                   className="btn fw-bold px-4 py-2" 
//                   style={{ background: `linear-gradient(135deg, ${colors.cyan}, #40bda9)`, color: colors.blue, borderRadius: '12px', border: 'none', fontSize: '13px' }}
//                 >
//                   Start Live Match
//                 </button>
//               </div>

//      {/* Connected players grid wrapper */}
//           {!connectedPlayers || connectedPlayers.length === 0 ? (
//             <div className="text-center py-5 text-muted">
//               <p className="mb-0" style={{ fontSize: '14px', fontStyle: 'italic' , color:"#fff"}}>
//                 Waiting for participants to input PIN sequence or scan QR code vector...
//               </p>
//             </div>
//           ) : (
//             <div className="d-flex flex-wrap gap-2 justify-content-start pt-2">
//               {connectedPlayers.map((player, pIdx) => {
//                 // Defensive extraction supporting both object layouts and plain strings
//                 const playerName = typeof player === 'object' ? (player.name || player.Name) : player;
                
//                 return (
//                   <span key={pIdx} className="px-3 py-2 fw-bold animate-fade-in" style={{ background: 'rgba(255,255,255,0.08)', borderRadius: '30px', color: colors.cyan, fontSize: '13px', border: '1px solid rgba(99,222,204,0.15)' }}>
//                     👤 {playerName}
//                   </span>
//                 );
//               })}
//             </div>
//           )}
//             </div> 
//           </div>
//         )}

//         {/* ACTIVE QUESTION OR REVEAL GRAPHICS DISPLAY LAYER STAGE */}
//         {(gameState.game_stage === 'question' || gameState.game_stage === 'reveal') && currentQuestion && (
//           <div className="max-width-xl mx-auto" style={{ maxWidth: '960px' }}>
            
//             {/* Elegant Floating Question Headline Banner */}
//             <div className="text-dark p-4 rounded-4 text-center mb-5 shadow-lg" style={{ background: '#ffffff', borderBottom: `4px solid ${colors.orange}` }}>
//               <span className="badge bg-secondary mb-2" style={{ fontSize: '11px' }}>QUESTION {gameState.current_question_index + 1} OF {questions.length}</span>
//               <h2 className="fw-bold m-0" style={{ fontSize: '26px', letterSpacing: '-0.5px', color: colors.textMain }}>{currentQuestion.question}</h2>
//             </div>

//             {/* Timer and Action Controls Row */}
//             <div className="d-flex justify-content-between align-items-center mb-5 px-2">
//               <div style={{ 
//                 background: gameState.seconds_left <= 5 ? '#e21b3c' : 'rgba(255,255,255,0.05)', 
//                 border: `2px solid ${gameState.seconds_left <= 5 ? '#e21b3c' : colors.cyan}`, 
//                 borderRadius: '50%', width: '75px', height: '75px', 
//                 display: 'flex', alignItems: 'center', justifyContent: 'center', 
//                 fontSize: '28px', Jakartafw: '800', color: '#ffffff',
//                 transition: 'all 0.3s ease',
//                 boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
//               }}>
//                 {gameState.seconds_left > 0 ? gameState.seconds_left : 0}
//               </div>
              
//               <button 
//                 onClick={handleNextAction} 
//                 className="btn fw-bold px-4 py-2.5 text-white" 
//                 style={{ backgroundColor: colors.orange, borderRadius: '12px', border: 'none', fontSize: '14px', boxShadow: '0 8px 20px rgba(243,80,24,0.2)' }}
//               >
//                 {gameState.game_stage === 'question' ? 'Skip Timer ⏭️' : 'Next Question ➡️'}
//               </button>
//             </div>

//             {/* Answer Display Quadrant Grid Matrix Array */}
//             <div className="row g-4">
//               {[currentQuestion.option_1, currentQuestion.option_2, currentQuestion.option_3, currentQuestion.option_4].map((opt, idx) => {
//                 const isCorrectOpt = opt === currentQuestion.correct_answer;
//                 const showCheck = gameState.game_stage === 'reveal' && isCorrectOpt;
                
//                 return (
//                   <div key={idx} className="col-12 col-md-6">
//                     <div style={{
//                       background: premiumColors[idx],
//                       opacity: gameState.game_stage === 'reveal' && !isCorrectOpt ? 0.25 : 1,
//                       padding: '35px 25px', 
//                       borderRadius: '18px', 
//                       fontSize: '18px', 
//                       fontWeight: '700', 
//                       position: 'relative',
//                       boxShadow: '0 15px 30px rgba(0,0,0,0.15)',
//                       border: showCheck ? '3px solid #ffffff' : '1px solid rgba(255,255,255,0.1)',
//                       transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
//                     }}>
//                       <div className="d-flex align-items-center gap-3">
//                         <span style={{ display: 'inline-block', width: '28px', height: '28px', borderRadius: '6px', background: 'rgba(255,255,255,0.2)', textAlign: 'center', fontSize: '13px', lineHeight: '28px' }}>
//                           {idx + 1}
//                         </span>
//                         <span className="text-white">{opt || "Option configuration parameter empty."}</span>
//                       </div>
//                       {showCheck && (
//                         <span style={{ position: 'absolute', right: '25px', top: '50%', transform: 'translateY(-50%)', fontSize: '26px' }}>
//                           ✅
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* FINAL SESSION COMPLETION CHAMPIONSHIP PODIUM STAGE */}
//         {/* {gameState.game_stage === 'podium' && (
//           <div className="text-center py-5 animate-fade-in" style={{ maxWidth: '600px', margin: '0 auto' }}>
//             <div style={{ fontSize: '72px', marginBottom: '20px' }}>🏆</div>
//             <h1 className="fw-bold mb-2" style={{ color: colors.cyan, letterSpacing: '-1px' }}>Session Complete</h1>
//             <p className="text-white mb-5">All question matrices processed. Participant metrics successfully committed to persistent leaderboard tables.</p>
//             <button 
//               onClick={() => navigate(-1)} 
//               className="btn btn-lg w-100 fw-bold py-3 text-white" 
//               style={{ background: `linear-gradient(135deg, #ff6b6b, #e21b3c)`, border: 'none', borderRadius: '16px' }}
//             >
//               Exit Match Arena
//             </button>
//           </div>
//         )} */}

//         {/* FINAL SESSION COMPLETION CHAMPIONSHIP PODIUM STAGE */}
//         {gameState.game_stage === 'podium' && (
//           <div className="animate-fade-in mx-auto px-2" style={{ maxWidth: '1200px' }}>
            
//             {/* Header Title Section */}
//             <div className="text-center mb-5">
//               <div style={{ fontSize: '64px', marginBottom: '10px' }}>🏆</div>
//               <h1 className="fw-bold m-0" style={{ color: colors.cyan, letterSpacing: '-1px', fontSize: '36px' }}>
//                 Championship Podium
//               </h1>
//               <p className="text-muted">Final match standings committed to permanent session logs</p>
//             </div>

//             <div className="row g-5 align-items-end justify-content-center">
              
//               {/* LEFT COLUMN PANEL: 3D Championship Podium Blocks */}
//               <div className="col-12 col-lg-7 d-flex align-items-end justify-content-center px-3" style={{ minHeight: '380px', marginBottom: '20px' }}>
//                 <div className="d-flex align-items-end justify-content-center gap-3 w-100">
                  
//                   {/* 2nd Place Pillar */}
//                   <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '160px' }}>
//                     {leaderboard[1] && (
//                       <div className="text-center mb-2 animate-fade-in">
//                         <div className="fw-bold truncate text-truncate" style={{ fontSize: '16px', maxWidth: '140px', color: '#fff' }}>
//                           {typeof leaderboard[1] === 'object' ? (leaderboard[1].name || leaderboard[1].Name) : leaderboard[1]}
//                         </div>
//                         <div className="small fw-semibold" style={{ color: colors.cyan }}>
//                           {leaderboard[1].total_accumulated_marks} pts
//                         </div>
//                       </div>
//                     )}
//                     <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
//                       height: '160px', 
//                       background: 'linear-gradient(180deg, #1e1f4b 0%, rgba(30,31,75,0.4) 100%)', 
//                       border: '2px solid rgba(255,255,255,0.1)', 
//                       borderRadius: '16px 16px 0 0',
//                       boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
//                     }}>
//                       <span className="fw-extrabold" style={{ fontSize: '48px', color: '#a0aec0', opacity: 0.8 }}>2</span>
//                     </div>
//                   </div>

//                   {/* 1st Place Pillar (Center & Highest) */}
//                   <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '180px' }}>
//                     {leaderboard[0] && (
//                       <div className="text-center mb-2 animate-bounce">
//                         <div style={{ fontSize: '28px', marginBottom: '-5px' }}>👑</div>
//                         <div className="fw-bold truncate text-truncate" style={{ fontSize: '18px', maxWidth: '160px', color: '#fff' }}>
//                           {typeof leaderboard[0] === 'object' ? (leaderboard[0].name || leaderboard[0].Name) : leaderboard[0]}
//                         </div>
//                         <div className="fw-bold" style={{ color: colors.orange }}>
//                         {leaderboard[0].total_accumulated_marks} pts
//                         </div>
//                       </div>
//                     )}
//                     <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
//                       height: '220px', 
//                       background: `linear-gradient(180deg, ${colors.orange} 0%, rgba(243,80,24,0.2) 100%)`, 
//                       border: `2px solid ${colors.orange}`, 
//                       borderRadius: '16px 16px 0 0',
//                       boxShadow: '0 25px 50px rgba(243,80,24,0.3)'
//                     }}>
//                       <span className="fw-extrabold text-white" style={{ fontSize: '64px' }}>1</span>
//                     </div>
//                   </div>

//                   {/* 3rd Place Pillar */}
//                   <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '140px' }}>
//                     {leaderboard[2] && (
//                       <div className="text-center mb-2 animate-fade-in">
//                         <div className="fw-bold truncate text-truncate" style={{ fontSize: '14px', maxWidth: '120px', color: '#fff' }}>
//                           {typeof leaderboard[2] === 'object' ? (leaderboard[2].name || leaderboard[2].Name) : leaderboard[2]}
//                         </div>
//                         <div className="small fw-semibold" style={{ color: colors.cyan }}>
//                           {leaderboard[2].total_accumulated_marks} pts
//                         </div>
//                       </div>
//                     )}
//                     <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
//                       height: '120px', 
//                       background: 'linear-gradient(180deg, #16173a 0%, rgba(22,23,58,0.3) 100%)', 
//                       border: '2px solid rgba(255,255,255,0.06)', 
//                       borderRadius: '16px 16px 0 0',
//                       boxShadow: '0 15px 30px rgba(0,0,0,0.4)'
//                     }}>
//                       <span className="fw-extrabold" style={{ fontSize: '36px', color: '#ed8936', opacity: 0.7 }}>3</span>
//                     </div>
//                   </div>

//                 </div>
//               </div>

//               {/* RIGHT COLUMN PANEL: Scannable Participant Standings Board */}
//               <div className="col-12 col-lg-5">
//                 <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', padding: '25px', borderRadius: '24px', maxHeight: '420px', overflowY: 'auto' }}>
//                   <h4 className="fw-bold mb-3 border-bottom border-secondary pb-2" style={{ fontSize: '16px', color: '#fff', borderColor: 'rgba(255,255,255,0.1) !important' }}>
//                     All Participant Standings
//                   </h4>
                  
//                   {leaderboard.length === 0 ? (
//                     <p className="text-muted small italic m-0">No score metrics available.</p>
//                   ) : (
//                     <div className="d-flex flex-column gap-2">
//                       {leaderboard.map((player, index) => {
//                         const name = typeof player === 'object' ? (player.name || player.Name) : player;
//                     const score = player.total_accumulated_marks || 0;
                        
//                         return (
//                           <div key={index} className="d-flex justify-content-between align-items-center px-3 py-2.5 rounded-3" style={{ background: index < 3 ? 'rgba(99,222,204,0.05)' : 'rgba(255,255,255,0.02)', border: index < 3 ? `1px solid rgba(99,222,204,0.15)` : '1px solid transparent' }}>
//                             <div className="d-flex align-items-center gap-2">
//                               <span className="fw-bold small text-muted" style={{ minWidth: '24px' }}>#{index + 1}</span>
//                               <span className="fw-semibold" style={{ color: index === 0 ? colors.cyan : '#fff' }}>👤 {name}</span>
//                             </div>
//                             <span className="fw-bold text-end" style={{ color: index === 0 ? colors.orange : colors.cyan }}>
//                               {score} <span className="small text-muted fw-normal" style={{ fontSize: '11px' }}>pts</span>
//                             </span>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               </div>

//             </div>

//             {/* Bottom Form Actions Grid */}
//             <div className="text-center mt-5">
//               <button 
//                 onClick={() => navigate(-1)} 
//                 className="btn btn-lg px-5 fw-bold py-3 text-white" 
//                 style={{ background: `linear-gradient(135deg, #ff6b6b, ${premiumColors[0]})`, border: 'none', borderRadius: '16px', boxShadow: '0 10px 25px rgba(226,27,60,0.2)' }}
//               >
//                 Exit Match Arena Layout
//               </button>
//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default HostLiveRoom;


import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IoCloseCircleOutline } from 'react-icons/io5';
import QRCode from 'react-qr-code';
import axios from 'axios';

// Unified Base API Endpoint (Consistent HTTP port)
const API_BASE = 'https://rvapi.emedha.in';

const HostLiveRoom = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // Defensively extract room parameters from React Router State or URL parameters
  const pin = location.state?.pin || params?.roomPin;
  const initialEventId = location.state?.eventId || null;
  const userId = location.state?.userId || null;
  const certMode = location.state?.certMode || false;

  const [activeEventId, setActiveEventId] = useState(initialEventId);
  const [gameState, setGameState] = useState({ game_stage: 'lobby', current_question_index: 0, seconds_left: 0 });
  const [questions, setQuestions] = useState([]);
  const [connectedPlayers, setConnectedPlayers] = useState([]);


const [questionAttempts, setQuestionAttempts] = useState([]);

  const [maxAllowedPlayers, setMaxAllowedPlayers] = useState(100);

  // Local game rules
  const [customDuration, setCustomDuration] = useState(30);
  const [customMarks, setCustomMarks] = useState(10);
  const [leaderboard, setLeaderboard] = useState([]);

  // Always valid join URL
  const joinUrl = location.state?.joinUrl || `${window.location.origin}/join?pin=${pin}${activeEventId ? `&eventId=${activeEventId}` : ''}`;

  const isAutoAdvancing = useRef(false);

  const colors = {
    orange: '#f35018',
    blue: '#2f3194',
    cyan: '#63decc',
    textMain: '#0f1137'
  };

  const premiumColors = ['#e21b3c', '#1368ce', '#d89e00', '#26890c'];

  // 1. Guard against missing PIN
  useEffect(() => {
    if (!pin) {
      console.error("[HostLiveRoom] Missing PIN parameter. Redirecting to Dashboard.");
      alert("Invalid room parameters detected.");
      navigate('/Dashboard/45g676tr/Dashboard');
    }
  }, [pin, navigate]);


  // Clear attempts list whenever question index advances to a new question
  useEffect(() => {
    setQuestionAttempts([]);
  }, [gameState.current_question_index]);


  // 2. Fetch or recover eventId and subscription limit
  useEffect(() => {
    if (!pin) return;

    const resolveEventAndQuestions = async () => {
      let targetEvent = activeEventId;

      try {
        console.log("[HostLiveRoom] Querying PIN verification for quota & event:", pin);
        const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${pin}`);
        
        if (verifyRes.data?.valid) {
          // ALWAYS set the subscription limit from the API response
          if (verifyRes.data.maxParticipants !== undefined) {
            console.log("[HostLiveRoom] Received maxParticipants:", verifyRes.data.maxParticipants);
            setMaxAllowedPlayers(Number(verifyRes.data.maxParticipants));
          }

          if (!targetEvent && verifyRes.data.eventId) {
            targetEvent = verifyRes.data.eventId;
            setActiveEventId(targetEvent);
          }
        }
      } catch (err) {
        console.error("[HostLiveRoom] Error verifying PIN for quota:", err);
      }

      if (targetEvent && questions.length === 0) {
        try {
          const qRes = await axios.get(`${API_BASE}/pages/api/api/questions?eventId=${targetEvent}`);
          if (Array.isArray(qRes.data)) {
            setQuestions(qRes.data);
          }
        } catch (err) {
          console.error("[HostLiveRoom] Error loading questionnaire:", err);
        }
      }
    };

    resolveEventAndQuestions();
  }, [pin]);

  // 2. Fetch or recover eventId if entering from Dashboard without state
  useEffect(() => {
    if (!pin) return;

    const resolveEventAndQuestions = async () => {
      let targetEvent = activeEventId;

      if (!targetEvent) {
        try {
          console.log("[HostLiveRoom] Resolving eventId from PIN verification:", pin);
          const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${pin}`);
          if (verifyRes.data?.valid) {
            targetEvent = verifyRes.data.eventId;
            setActiveEventId(targetEvent);
            if (verifyRes.data.maxParticipants !== undefined) {
          setMaxAllowedPlayers(Number(verifyRes.data.maxParticipants));
        }
            console.log("[HostLiveRoom] Recovered eventId:", targetEvent);
          }
        } catch (err) {
          console.error("[HostLiveRoom] Error verifying PIN for event recovery:", err);
        }
      }

      if (targetEvent && questions.length === 0) {
        try {
          console.log("[HostLiveRoom] Fetching questions for event:", targetEvent);
          const qRes = await axios.get(`${API_BASE}/pages/api/api/questions?eventId=${targetEvent}`);
          if (Array.isArray(qRes.data)) {
            setQuestions(qRes.data);
            console.log("[HostLiveRoom] Loaded questions count:", qRes.data.length);
          }
        } catch (err) {
          console.error("[HostLiveRoom] Error loading questionnaire:", err);
        }
      }
    };

    resolveEventAndQuestions();
  }, [pin, activeEventId, questions.length]);

  // 3. Main synchronization engine
  useEffect(() => {
    if (!pin) return;

    const syncEngine = async () => {
      try {
        const stateRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${pin}`);
        const currentState = stateRes.data;
        console.log("[HostLiveRoom] Polled Game State:", currentState);

        setGameState(currentState);

        // Fetch lobby players while waiting in lobby OR scheduled stage
        if (currentState.game_stage === 'lobby' || currentState.game_stage === 'scheduled') {
          const playersRes = await axios.get(`${API_BASE}/pages/api/api/quiz/live-lobby-players/${pin}`);
          if (Array.isArray(playersRes.data)) {
            setConnectedPlayers(playersRes.data);
          }
        }

        // Fetch podium rankings if game reaches podium
        if (currentState.game_stage === 'podium') {
          const rankRes = await axios.get(`${API_BASE}/pages/api/api/quiz/podium-standings/${pin}`);
          if (Array.isArray(rankRes.data)) {
            setLeaderboard(rankRes.data);
          }
        }

// 👉 ADD THIS: Fetch live question submissions during question or reveal stage
        if (currentState.game_stage === 'question' || currentState.game_stage === 'reveal') {
          // Get questionId from active_question or questions array
          const activeQId = currentState.active_question?.id || questions[currentState.current_question_index]?.id;
          
          if (activeQId) {
            try {
              const respRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/live-question-responses/${pin}/${activeQId}`);
              if (Array.isArray(respRes.data)) {
                setQuestionAttempts(respRes.data);
              }
            } catch (respErr) {
              console.error("[HostLiveRoom] Error fetching live question responses:", respErr);
            }
          }
        }

      } catch (err) {
        console.error("[HostLiveRoom] Polling error in syncEngine:", err);
      }
    };

    const initialDelay = setTimeout(syncEngine, 300);
    const intervalId = setInterval(syncEngine, 1000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(intervalId);
    };
  }, [pin]);

  // 4. Automatic stage progression (CRITICAL: Guarded against scheduled & lobby states)
  useEffect(() => {
    if (!pin || isAutoAdvancing.current) return;

    // NEVER auto-advance when in scheduled, lobby, or podium!
    if (gameState.game_stage === 'scheduled' || gameState.game_stage === 'lobby' || gameState.game_stage === 'podium') {
      return;
    }

    // Auto-advance from 'question' to 'reveal' when seconds hit 0
    if (gameState.game_stage === 'question' && gameState.seconds_left <= 0 && questions.length > 0) {
      isAutoAdvancing.current = true;
      console.log("[HostLiveRoom] Timer reached zero. Advancing to reveal.");

      axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
        roomPin: pin,
        nextStage: 'reveal',
        nextIndex: gameState.current_question_index,
        duration: 0,
        questionMarks: customMarks,
      })
      .catch((err) => console.error("[HostLiveRoom] Auto reveal failed:", err))
      .finally(() => {
        setTimeout(() => { isAutoAdvancing.current = false; }, 1200);
      });
    }

    // Auto-advance from 'reveal' to next question or podium after 4 seconds
    if (gameState.game_stage === 'reveal' && questions.length > 0) {
      const revealTimer = setTimeout(async () => {
        if (isAutoAdvancing.current) return;
        isAutoAdvancing.current = true;

        const nextIndex = gameState.current_question_index + 1;
        const isMatchFinished = nextIndex >= questions.length;
        console.log(`[HostLiveRoom] Advancing from reveal. Next index: ${nextIndex}, Finished: ${isMatchFinished}`);

        try {
          await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
            roomPin: pin,
            nextStage: isMatchFinished ? 'podium' : 'question',
            nextIndex: isMatchFinished ? 0 : nextIndex,
            duration: isMatchFinished ? 0 : customDuration,
            questionMarks: isMatchFinished ? 0 : customMarks,
          });

          if (isMatchFinished) {
            axios.post(`${API_BASE}/pages/api/api/quiz/finish-session`, {
              roomPin: pin,
              eventId: activeEventId
            }).catch(e => console.error("[HostLiveRoom] Error finalizing session:", e));
          }
        } catch (err) {
          console.error("[HostLiveRoom] Auto progression failed:", err);
        } finally {
          setTimeout(() => { isAutoAdvancing.current = false; }, 1200);
        }
      }, 4000);

      return () => clearTimeout(revealTimer);
    }
  }, [gameState.game_stage, gameState.seconds_left, gameState.current_question_index, pin, questions.length, customDuration, customMarks, activeEventId]);




// DEDICATED PODIUM FINALIZER: Triggered immediately whenever game_stage reaches 'podium'
  const hasFinishedSession = useRef(false);

  useEffect(() => {
    if (gameState.game_stage === 'podium' && !hasFinishedSession.current && pin) {
      hasFinishedSession.current = true;
      console.log(`[HostLiveRoom] Match reached PODIUM for room ${pin}. Finalizing session in database...`);

      axios.post(`https://rvapi.emedha.in/pages/api/api/quiz/finish-session`, {
        roomPin: pin,
        eventId: activeEventId || initialEventId
      })
      .then(res => {
        console.log("[HostLiveRoom] Session marked as 'ended' and event locked successfully:", res.data);
      })
      .catch(err => {
        console.error("[HostLiveRoom] Failed to mark session as ended:", err);
        hasFinishedSession.current = false; // Allow retry on error
      });
    }
  }, [gameState.game_stage, pin, activeEventId, initialEventId]);



  
  // 5. Host Action: Start Match
  const handleStartGame = async () => {
    try {
      console.log("[HostLiveRoom] Host clicked Start Live Match.");
      await axios.post(`${API_BASE}/pages/api/api/quiz/start-game`, { 
        roomPin: pin, 
        totalDuration: customDuration,
        questionMarks: customMarks
      });

      await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
        roomPin: pin,
        nextStage: 'question',
        nextIndex: 0,
        duration: customDuration,
        questionMarks: customMarks
      });
    } catch (err) {
      console.error("[HostLiveRoom] Failed to start game loop:", err);
      alert("Failed to start live match. Check server connection.");
    }
  };

  // 6. Manual Skip / Next Action
  // const handleNextAction = async () => {
  //   if (isAutoAdvancing.current) return;
  //   isAutoAdvancing.current = true;

  //   const isReveal = gameState.game_stage === 'question';
  //   const nextStage = isReveal ? 'reveal' : 'question';
  //   const nextIndex = isReveal ? gameState.current_question_index : gameState.current_question_index + 1;

  //   try {
  //     if (!isReveal && nextIndex >= questions.length) {
  //       await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, { 
  //         roomPin: pin, 
  //         nextStage: 'podium', 
  //         nextIndex: 0, 
  //         duration: 0, 
  //         questionMarks: 0 
  //       });
  //       return;
  //     }

  //     await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
  //       roomPin: pin,
  //       nextStage,
  //       nextIndex,
  //       duration: isReveal ? 0 : customDuration,
  //       questionMarks: customMarks
  //     });
  //   } catch (err) {
  //     console.error("[HostLiveRoom] Manual stage transition error:", err);
  //   } finally {
  //     setTimeout(() => { isAutoAdvancing.current = false; }, 800);
  //   }
  // };

// const handleNextAction = async () => {
//     if (isAutoAdvancing.current) return;
//     isAutoAdvancing.current = true;

//     const isReveal = gameState.game_stage === 'question';
//     const nextStage = isReveal ? 'reveal' : 'question';
//     const nextIndex = isReveal ? gameState.current_question_index : gameState.current_question_index + 1;

//     try {
//       if (!isReveal && nextIndex >= questions.length) {
//         // 1. Advance state to podium
//         await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, { 
//           roomPin: pin, 
//           nextStage: 'podium', 
//           nextIndex: 0, 
//           duration: 0, 
//           questionMarks: 0 
//         });

//         // 2. Mark session ended and lock event
//         await axios.post(`${API_BASE}/pages/api/api/quiz/finish-session`, {
//           roomPin: pin,
//           eventId: activeEventId || initialEventId
//         }).catch(e => console.error("[HostLiveRoom] Error finalizing session on manual skip:", e));

//         return;
//       }

//       await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
//         roomPin: pin,
//         nextStage,
//         nextIndex,
//         duration: isReveal ? 0 : customDuration,
//         questionMarks: customMarks
//       });
//     } catch (err) {
//       console.error("[HostLiveRoom] Manual stage transition error:", err);
//     } finally {
//       setTimeout(() => { isAutoAdvancing.current = false; }, 800);
//     }
//   };


const handleNextAction = async () => {
    if (isAutoAdvancing.current) return;
    isAutoAdvancing.current = true;

    const isReveal = gameState.game_stage === 'question';
    const nextStage = isReveal ? 'reveal' : 'question';
    const nextIndex = isReveal ? gameState.current_question_index : gameState.current_question_index + 1;

    try {
      if (!isReveal && nextIndex >= questions.length) {
        // 1. Advance state to podium on server
        await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, { 
          roomPin: pin, 
          nextStage: 'podium', 
          nextIndex: 0, 
          duration: 0, 
          questionMarks: 0 
        });

        // 2. Mark session ended in database
        await axios.post(`${API_BASE}/pages/api/api/quiz/finish-session`, {
          roomPin: pin,
          eventId: activeEventId || initialEventId
        }).catch(e => console.error("[HostLiveRoom] Error finalizing session on manual skip:", e));

   
        setGameState(prev => ({
          ...prev,
          game_stage: 'podium',
          seconds_left: 0
        }));

        return;
      }

      await axios.post(`${API_BASE}/pages/api/api/quiz/advance-stage`, {
        roomPin: pin,
        nextStage,
        nextIndex,
        duration: isReveal ? 0 : customDuration,
        questionMarks: customMarks
      });
    } catch (err) {
      console.error("[HostLiveRoom] Manual stage transition error:", err);
    } finally {
      setTimeout(() => { isAutoAdvancing.current = false; }, 800);
    }
  };


  // 7. Close / Exit Room Handler
  const handleCloseRoomScrub = async () => {
  const confirmation = window.confirm(
      "⚠️ PERMANENT ROOM CLOSURE WARNING ⚠️\n\n" +
      "Are you sure you want to exit and close this live room?\n\n" +
      "• This room PIN will be PERMANENTLY TERMINATED.\n" +
      "• All connected participants will be disconnected immediately.\n" +
      "• You CANNOT reopen, rejoin, or resume this room once closed.\n" +
      "• The match will be recorded as 'ABANDONED'.\n\n" +
      "Click 'OK' to permanently close the room, or 'Cancel' to keep playing."
    );
    if (!confirmation) return;

    try {
      if (gameState.game_stage !== 'podium') {
        await axios.post(`${API_BASE}/pages/api/api/quiz/abandon-session`, { roomPin: pin });
      } else {
        await axios.post(`${API_BASE}/pages/api/api/quiz/finish-session`, { roomPin: pin, eventId: activeEventId });
      }
      navigate('/Dashboard/45g676tr/Dashboard');
    } catch (error) {
      console.error("[HostLiveRoom] Error ending session:", error);
      navigate('/Dashboard/45g676tr/Dashboard');
    }
  };

  const currentQuestion = questions[gameState.current_question_index];

  return (
    <div style={{ 
      background: 'radial-gradient(circle at top right, #1e1f4b 0%, #0b0c26 100%)', 
      fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
      minHeight: '100vh', 
      color: '#ffffff', 
      padding: '40px 20px' 
    }}>
      
      {/* Top Header Management Bar */}
      <div className="d-flex justify-content-between align-items-center mb-5 max-width-xl mx-auto px-4">
        <div>
          <span style={{ color: colors.cyan, fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase' }}>
            Live Match Lobby — Stage: {gameState.game_stage}
          </span>
          <h1 className="m-0 fw-bold" style={{ fontSize: '24px', letterSpacing: '-0.5px' }}>
            Quizify<span style={{ color: colors.orange }}>AI</span> Live
          </h1>
        </div>
       {/* {gameState.game_stage !== 'podium' ? (
        <>
        <button 
            onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
            className="btn d-flex align-items-center gap-2 px-3 py-2" 
            style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(99,222,204,0.3)', color: colors.cyan, borderRadius: '12px', fontSize: '13px', fontWeight: '600' }}
          >
            Dashboard ➔
          </button>

          <button 
            onClick={handleCloseRoomScrub} 
            className="btn d-flex align-items-center gap-2 px-3 py-2" 
            style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: '#ff6b6b', borderRadius: '12px', fontSize: '13px' }}
          >
            <IoCloseCircleOutline size={18} /> Close Room
          </button>
          </>
        ) : (
          <button 
            onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
            className="btn d-flex align-items-center gap-2 px-3 py-2" 
            style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(99,222,204,0.3)', color: colors.cyan, borderRadius: '12px', fontSize: '13px', fontWeight: '600' }}
          >
            Dashboard ➔
          </button>
        )} */}
        <div className="d-flex align-items-center gap-2">
          {/* 1. LOBBY & SCHEDULED: Safe to check Dashboard or Close Room */}
          {(gameState.game_stage === 'lobby' || gameState.game_stage === 'scheduled') && (
            <>
              <button 
                onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
                className="btn d-flex align-items-center gap-2 px-3 py-2" 
                style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(99,222,204,0.3)', color: colors.cyan, borderRadius: '12px', fontSize: '13px', fontWeight: '600' }}
              >
                Dashboard ➔
              </button>

              <button 
                onClick={handleCloseRoomScrub} 
                className="btn d-flex align-items-center gap-2 px-3 py-2" 
                style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: '#ff6b6b', borderRadius: '12px', fontSize: '13px' }}
              >
                <IoCloseCircleOutline size={18} /> Close Room
              </button>
            </>
          )}

          {/* 2. QUESTION & REVEAL: ONLY allow Close Room (with its strong warning) to prevent accidental exits */}
          {(gameState.game_stage === 'question' || gameState.game_stage === 'reveal') && (
            <button 
              onClick={handleCloseRoomScrub} 
              className="btn d-flex align-items-center gap-2 px-3 py-2" 
              style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: '#ff6b6b', borderRadius: '12px', fontSize: '13px' }}
            >
              <IoCloseCircleOutline size={18} /> Close Room
            </button>
          )}

          {/* 3. PODIUM: Game is finished, only allow safe exit to Dashboard */}
          {gameState.game_stage === 'podium' && (
            <button 
              onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
              className="btn d-flex align-items-center gap-2 px-3 py-2" 
              style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(99,222,204,0.3)', color: colors.cyan, borderRadius: '12px', fontSize: '13px', fontWeight: '600' }}
            >
              Dashboard ➔
            </button>
          )}
        </div>
      </div>

      <div className="container-xl">
        
        {/* VIEW 1: LOBBY & SCHEDULED INTERFACE */}
        {(gameState.game_stage === 'lobby' || gameState.game_stage === 'scheduled') && (
          <div>
            {gameState.game_stage === 'scheduled' && (
              <div className="alert alert-warning text-center mx-auto mb-4 py-2" style={{ maxWidth: '600px', borderRadius: '12px', fontWeight: '600' }}>
                📅 Scheduled Session — Click "Start Live Match" below when you are ready to start live questions!
              </div>
            )}

            <div className="row g-4 align-items-center justify-content-center">
              {/* PIN Display Block */}
              <div className="col-12 col-md-6 col-lg-5 text-center text-md-start">
                <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', padding: '40px', borderRadius: '28px', backdropFilter: 'blur(10px)' }}>
                  <p className="mb-2 fw-semibold" style={{ fontSize: '13px', letterSpacing: '1px' }}>JOINING DIRECTIONS</p>
                  <h2 className="mb-4" style={{ fontSize: '20px', fontWeight: '500', lineHeight: '1.4' }}>
                    Open the portal page and input the authorization sequence code:
                  </h2>
                  
                  <div style={{ 
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)', 
                    border: `1px solid rgba(99, 222, 204, 0.25)`, 
                    padding: '20px 40px', 
                    borderRadius: '20px', 
                    display: 'inline-block', 
                    fontSize: '48px', 
                    fontWeight: '800', 
                    color: colors.cyan, 
                    letterSpacing: '4px', 
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)' 
                  }}>
                    {pin}
                  </div>

                  <div className="mt-4">
                    <small className="d-block mb-1">DIRECT LINK INSTANCE</small>
                    <code style={{ color: colors.cyan, fontSize: '12px', wordBreak: 'break-all' }}>{joinUrl}</code>
                  </div>
                </div>
              </div>

              {/* QR Code Canvas */}
              <div className="col-12 col-md-5 col-lg-4 text-center">
                <div style={{ background: '#ffffff', padding: '30px', borderRadius: '28px', display: 'inline-block', boxShadow: '0 30px 60px rgba(0,0,0,0.4)' }}>
                  <div style={{ background: '#ffffff', padding: '15px', borderRadius: '16px', border: '1px solid #f0f0f0' }}>
                    {joinUrl && (
                      <QRCode 
                        value={joinUrl} 
                        size={220} 
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }} 
                        viewBox={`0 0 250 250`} 
                      />
                    )}
                  </div>
                  <p className="mb-0 mt-3 fw-bold" style={{ color: colors.blue, fontSize: '13px', letterSpacing: '0.3px' }}>
                    📷 SCAN QR TO JOIN GAME
                  </p>
                </div>
              </div>
            </div>

            {/* Waiting Room & Configuration Controls */}
            <div className="mt-5 max-width-xl mx-auto px-3">
              <div className="row g-3 mb-4 p-4 rounded-4 justify-content-center align-items-center" style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                <div className="col-12 col-sm-5 col-md-4">
                  <label className="form-label small fw-bold tracking-wide text-uppercase" style={{ color: colors.cyan }}>⏱️ Question Timer (Seconds)</label>
                  <input 
                    type="number" 
                    className="form-control text-center text-white fw-bold" 
                    style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(99,222,204,0.2)', borderRadius: '10px' }} 
                    min={5} 
                    max={120} 
                    value={customDuration} 
                    onChange={(e) => setCustomDuration(parseInt(e.target.value) || 0)} 
                  />
                </div>
                <div className="col-12 col-sm-5 col-md-4">
                  <label className="form-label small fw-bold tracking-wide text-uppercase" style={{ color: colors.cyan }}>🎯 Points Per Question</label>
                  <input 
                    type="number" 
                    className="form-control text-center text-white fw-bold" 
                    style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(99,222,204,0.2)', borderRadius: '10px' }} 
                    min={1} 
                    max={1000} 
                    value={customMarks} 
                    onChange={(e) => setCustomMarks(parseInt(e.target.value) || 0)} 
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-secondary pb-2" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
              <h4 className="fw-bold m-0" style={{ fontSize: '16px', color: '#fff' }}>
  Waiting Room Lobby (
  <span style={{ color: colors.cyan }}>
    {connectedPlayers.length}
  </span>
  {maxAllowedPlayers === -1 ? ' / Unlimited' : ` / ${maxAllowedPlayers}`} players joined)
</h4>
                <button 
                  onClick={handleStartGame} 
                  className="btn fw-bold px-4 py-2" 
                  style={{ background: `linear-gradient(135deg, ${colors.cyan}, #40bda9)`, color: colors.blue, borderRadius: '12px', border: 'none', fontSize: '13px' }}
                >
                  Start Live Match
                </button>
              </div>

              {/* Connected Players Grid */}
              {!connectedPlayers || connectedPlayers.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <p className="mb-0" style={{ fontSize: '14px', fontStyle: 'italic', color: "#fff" }}>
                    Waiting for participants to input PIN or scan QR code...
                  </p>
                </div>
              ) : (
                <div className="d-flex flex-wrap gap-2 justify-content-start pt-2">
                  {connectedPlayers.map((player, pIdx) => {
                    const playerName = typeof player === 'object' ? (player.name || player.Name) : player;
                    return (
                      <span key={pIdx} className="px-3 py-2 fw-bold animate-fade-in" style={{ background: 'rgba(255,255,255,0.08)', borderRadius: '30px', color: colors.cyan, fontSize: '13px', border: '1px solid rgba(99,222,204,0.15)' }}>
                        👤 {playerName}
                      </span>
                    );
                  })}
                </div>
              )}
            </div> 
          </div>
        )}

        {/* VIEW 2: ACTIVE QUESTION OR REVEAL STAGES */}
        {/* {(gameState.game_stage === 'question' || gameState.game_stage === 'reveal') && (
          <div className="max-width-xl mx-auto" style={{ maxWidth: '960px' }}>
            
   
            {!currentQuestion ? (
              <div className="text-center py-5">
                <div className="spinner-border text-info mb-3"></div>
                <h4>Synchronizing question bank...</h4>
              </div>
            ) : (
              <>
                <div className="text-dark p-4 rounded-4 text-center mb-5 shadow-lg" style={{ background: '#ffffff', borderBottom: `4px solid ${colors.orange}` }}>
                  <span className="badge bg-secondary mb-2" style={{ fontSize: '11px' }}>QUESTION {gameState.current_question_index + 1} OF {questions.length}</span>
                  <h2 className="fw-bold m-0" style={{ fontSize: '26px', letterSpacing: '-0.5px', color: colors.textMain }}>{currentQuestion.question}</h2>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-5 px-2">
                  <div style={{ 
                    background: gameState.seconds_left <= 5 ? '#e21b3c' : 'rgba(255,255,255,0.05)', 
                    border: `2px solid ${gameState.seconds_left <= 5 ? '#e21b3c' : colors.cyan}`, 
                    borderRadius: '50%', width: '75px', height: '75px', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    fontSize: '28px', fontWeight: '800', color: '#ffffff', 
                    transition: 'all 0.3s ease', 
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)' 
                  }}>
                    {gameState.seconds_left > 0 ? gameState.seconds_left : 0}
                  </div>
                  
                  <button 
                    onClick={handleNextAction} 
                    className="btn fw-bold px-4 py-2.5 text-white" 
                    style={{ backgroundColor: colors.orange, borderRadius: '12px', border: 'none', fontSize: '14px', boxShadow: '0 8px 20px rgba(243,80,24,0.2)' }}
                  >
                    {gameState.game_stage === 'question' ? 'Skip Timer ⏭️' : 'Next Question ➡️'}
                  </button>
                </div>

                <div className="row g-4">
                  {[currentQuestion.option_1, currentQuestion.option_2, currentQuestion.option_3, currentQuestion.option_4].map((opt, idx) => {
                    const isCorrectOpt = opt === currentQuestion.correct_answer;
                    const showCheck = gameState.game_stage === 'reveal' && isCorrectOpt;
                    
                    return (
                      <div key={idx} className="col-12 col-md-6">
                        <div style={{ 
                          background: premiumColors[idx], 
                          opacity: gameState.game_stage === 'reveal' && !isCorrectOpt ? 0.25 : 1, 
                          padding: '35px 25px', 
                          borderRadius: '18px', 
                          fontSize: '18px', 
                          fontWeight: '700', 
                          position: 'relative', 
                          boxShadow: '0 15px 30px rgba(0,0,0,0.15)', 
                          border: showCheck ? '3px solid #ffffff' : '1px solid rgba(255,255,255,0.1)', 
                          transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)' 
                        }}>
                          <div className="d-flex align-items-center gap-3">
                            <span style={{ display: 'inline-block', width: '28px', height: '28px', borderRadius: '6px', background: 'rgba(255,255,255,0.2)', textAlign: 'center', fontSize: '13px', lineHeight: '28px' }}>
                              {idx + 1}
                            </span>
                            <span className="text-white">{opt || "No option specified"}</span>
                          </div>
                          {showCheck && (
                            <span style={{ position: 'absolute', right: '25px', top: '50%', transform: 'translateY(-50%)', fontSize: '26px' }}>
                              ✅
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )} */}

        {/* VIEW 2: ACTIVE QUESTION OR REVEAL STAGES */}
        {(gameState.game_stage === 'question' || gameState.game_stage === 'reveal') && (
          <div className="max-width-xl mx-auto" style={{ maxWidth: '1280px' }}>
            
            {!currentQuestion ? (
              <div className="text-center py-5">
                <div className="spinner-border text-info mb-3"></div>
                <h4>Synchronizing question bank...</h4>
              </div>
            ) : (
              <div className="row g-4">
                
                {/* LEFT SIDE: Question Title, Timer & Options (8 Columns) */}
                <div className="col-12 col-lg-8">
                  <div className="text-dark p-4 rounded-4 text-center mb-4 shadow-lg" style={{ background: '#ffffff', borderBottom: `4px solid ${colors.orange}` }}>
                    <span className="badge bg-secondary mb-2" style={{ fontSize: '11px' }}>
                      QUESTION {gameState.current_question_index + 1} OF {questions.length}
                    </span>
                    <h2 className="fw-bold m-0" style={{ fontSize: '24px', letterSpacing: '-0.5px', color: colors.textMain }}>
                      {currentQuestion.question}
                    </h2>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-4 px-2">
                    <div style={{ 
                      background: gameState.seconds_left <= 5 ? '#e21b3c' : 'rgba(255,255,255,0.05)', 
                      border: `2px solid ${gameState.seconds_left <= 5 ? '#e21b3c' : colors.cyan}`, 
                      borderRadius: '50%', width: '70px', height: '70px', 
                      display: 'flex', alignItems: 'center', justifyContent: 'center', 
                      fontSize: '26px', fontWeight: '800', color: '#ffffff', 
                      transition: 'all 0.3s ease', 
                      boxShadow: '0 10px 25px rgba(0,0,0,0.2)' 
                    }}>
                      {gameState.seconds_left > 0 ? gameState.seconds_left : 0}
                    </div>
                    
                    <button 
                      onClick={handleNextAction} 
                      className="btn fw-bold px-4 py-2.5 text-white" 
                      style={{ backgroundColor: colors.orange, borderRadius: '12px', border: 'none', fontSize: '14px', boxShadow: '0 8px 20px rgba(243,80,24,0.2)' }}
                    >
                      {gameState.game_stage === 'question' ? 'Skip Timer ⏭️' : 'Next Question ➡️'}
                    </button>
                  </div>

                  {/* 4 Options Grid (Handles both Text & Image Quiz) */}
                  <div className="row g-3">
                    {[0, 1, 2, 3].map((idx) => {
                      const optText = currentQuestion[`option_${idx + 1}`];
                      const optImg = currentQuestion[`images${idx + 1}`] || currentQuestion[`image_${idx + 1}`];

                      // Skip rendering empty 3rd or 4th options if neither text nor image exists
                      if (!optText && !optImg && idx >= 2) return null;

                      // Correct Answer Check for both Text and Image Quizzes
                      const isCorrectOpt = 
                        (optText && optText === currentQuestion.correct_answer) ||
                        (optImg && optImg === currentQuestion.correct_image);

                      const showCheck = gameState.game_stage === 'reveal' && isCorrectOpt;

                      return (
                        <div key={idx} className="col-12 col-md-6">
                          <div style={{ 
                            background: premiumColors[idx], 
                            opacity: gameState.game_stage === 'reveal' && !isCorrectOpt ? 0.25 : 1, 
                            padding: '18px 20px', 
                            borderRadius: '18px', 
                            position: 'relative', 
                            boxShadow: '0 15px 30px rgba(0,0,0,0.15)', 
                            border: showCheck ? '3px solid #22c55e' : '1px solid rgba(255,255,255,0.1)', 
                            transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                            minHeight: optImg ? '180px' : '90px'
                          }}>
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <span style={{ display: 'inline-block', width: '26px', height: '26px', borderRadius: '6px', background: 'rgba(255,255,255,0.25)', textAlign: 'center', fontSize: '12px', lineHeight: '26px', fontWeight: 'bold' }}>
                                {idx + 1}
                              </span>
                              {optText && <span className="text-white fw-bold" style={{ fontSize: '16px' }}>{optText}</span>}
                            </div>

                            {/* 👉 RENDER OPTION IMAGE IF PRESENT */}
                            {optImg && (
                              <div className="text-center mt-1">
                                <img 
                                  src={optImg} 
                                  alt={`Option ${idx + 1}`} 
                                  style={{ 
                                    maxHeight: '120px', 
                                    maxWidth: '100%', 
                                    borderRadius: '10px', 
                                    objectFit: 'contain',
                                    background: 'rgba(255,255,255,0.15)',
                                    padding: '4px'
                                  }} 
                                />
                              </div>
                            )}

                            {showCheck && (
                              <span style={{ position: 'absolute', right: '15px', top: '15px', fontSize: '26px' }}>
                                ✅
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* RIGHT SIDE: Live Question Attempts & Leaderboard (4 Columns) */}
                {/* <div className="col-12 col-lg-4">
                  <div style={{ 
                    background: 'rgba(255,255,255,0.03)', 
                    border: '1px solid rgba(255,255,255,0.08)', 
                    padding: '20px', 
                    borderRadius: '20px', 
                    backdropFilter: 'blur(10px)',
                    minHeight: '440px'
                  }}>
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
                      <h5 className="m-0 fw-bold" style={{ fontSize: '15px', color: colors.cyan }}>
                        ⚡ Live Question Submissions
                      </h5>
                      <span className="badge bg-info px-2 py-1" style={{ fontSize: '11px' }}>
                        {questionAttempts.length} Attempted
                      </span>
                    </div>

                    {questionAttempts.length === 0 ? (
                      <div className="text-center py-5 text-muted">
                        <div className="spinner-grow spinner-grow-sm text-info mb-2" role="status"></div>
                        <p className="small m-0 text-white opacity-75">Waiting for players to lock their answers...</p>
                      </div>
                    ) : (
                      <div className="d-flex flex-column gap-2" style={{ maxHeight: '380px', overflowY: 'auto',scrollbarWidth: 'thin',                      // Firefox కోసం
    scrollbarColor: 'rgba(99,222,204,0.3) transparent' }}>
                        {questionAttempts.map((attempt, aIdx) => (
                          <div 
                            key={aIdx} 
                            className="d-flex justify-content-between align-items-center px-3 py-2 rounded-3 animate-fade-in"
                            style={{ 
                              background: 'rgba(255,255,255,0.04)', 
                              border: '1px solid rgba(255,255,255,0.07)'
                            }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <span style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>
                                👤 {attempt.name}
                              </span>
                              <span className="badge rounded-pill bg-dark " style={{ fontSize: '10px' }}>
                                ⏱️ {attempt.seconds_taken}s
                              </span>
                            </div>

                            <div className="text-end">
                              {gameState.game_stage === 'reveal' ? (
                                <span className="fw-bold" style={{ color: attempt.is_correct ? '#22c55e' : '#ef4444', fontSize: '13px' }}>
                                  {attempt.is_correct ? `+${attempt.points_awarded} pts` : '0 pts'}
                                </span>
                              ) : (
                                <span className="badge bg-success" style={{ fontSize: '11px' }}>
                                  Answered ✓
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div> */}
                {/* RIGHT SIDE: Live Question Attempts & Leaderboard (4 Columns) */}
                <div className="col-12 col-lg-4">
                  <div style={{ 
                    background: 'rgba(255,255,255,0.03)', 
                    border: '1px solid rgba(255,255,255,0.08)', 
                    padding: '20px', 
                    borderRadius: '20px', 
                    backdropFilter: 'blur(10px)',
                    minHeight: '440px'
                  }}>
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
                      <h5 className="m-0 fw-bold" style={{ fontSize: '15px', color: colors.cyan }}>
                        ⚡ Live Question Submissions
                      </h5>
                      <span className="badge bg-info px-2 py-1" style={{ fontSize: '11px' }}>
                        {questionAttempts.filter(a => a.has_attempted === 1).length} / {questionAttempts.length} Answered
                      </span>
                    </div>

                    {questionAttempts.length === 0 ? (
                      <div className="text-center py-5 text-muted">
                        <div className="spinner-grow spinner-grow-sm text-info mb-2" role="status"></div>
                        <p className="small m-0 text-white opacity-75">Waiting for players to connect...</p>
                      </div>
                    ) : (
                      <div 
                        className="d-flex flex-column gap-2" 
                        style={{ 
                          maxHeight: '380px', 
                          overflowY: 'auto',
                          scrollbarWidth: 'thin',
                          scrollbarColor: 'rgba(99,222,204,0.3) transparent' 
                        }}
                      >
                        {questionAttempts.map((attempt, aIdx) => (
                          <div 
                            key={aIdx} 
                            className="d-flex justify-content-between align-items-center px-3 py-2 rounded-3 animate-fade-in"
                            style={{ 
                              background: attempt.has_attempted ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.01)', 
                              border: attempt.has_attempted ? '1px solid rgba(99,222,204,0.2)' : '1px solid rgba(255,255,255,0.04)',
                              opacity: attempt.has_attempted ? 1 : 0.65
                            }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <span style={{ fontSize: '13px', fontWeight: '700', color: attempt.has_attempted ? '#fff' : '#cbd5e1' }}>
                                👤 {attempt.name}
                              </span>
                              {attempt.has_attempted ? (
                                <span className="badge rounded-pill bg-dark" style={{ fontSize: '10px' }}>
                                  ⏱️ {attempt.seconds_taken}s
                                </span>
                              ) : (
                                <span className="badge rounded-pill bg-secondary" style={{ fontSize: '10px', opacity: 0.6 }}>
                                  ⏳ Pending
                                </span>
                              )}
                            </div>

                            <div className="text-end">
                              {gameState.game_stage === 'reveal' ? (
                                attempt.has_attempted ? (
                                  <span className="fw-bold" style={{ color: attempt.is_correct ? '#22c55e' : '#ef4444', fontSize: '13px' }}>
                                    {attempt.is_correct ? `+${attempt.points_awarded} pts` : '0 pts'}
                                  </span>
                                ) : (
                                  <span className="fw-semibold text-muted" style={{ fontSize: '12px' }}>
                                    0 pts (Missed)
                                  </span>
                                )
                              ) : (
                                attempt.has_attempted ? (
                                  <span className="badge bg-success" style={{ fontSize: '11px' }}>
                                    Answered ✓
                                  </span>
                                ) : (
                                  <span className="badge" style={{ background: 'rgba(255,255,255,0.1)', color: '#94a3b8', fontSize: '11px' }}>
                                    Thinking...
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

              </div>
            )}
          </div>
        )}

        {/* VIEW 3: PODIUM RESULTS STAGE */}
        {gameState.game_stage === 'podium' && (
          <div className="animate-fade-in mx-auto px-2" style={{ maxWidth: '1200px' }}>
            <div className="text-center mb-5">
              <div style={{ fontSize: '64px', marginBottom: '10px' }}>🏆</div>
              <h1 className="fw-bold m-0" style={{ color: colors.cyan, letterSpacing: '-1px', fontSize: '36px' }}>
                Championship Podium
              </h1>
              <p >Final match standings committed to permanent session logs</p>
            </div>

            <div className="row g-5 align-items-end justify-content-center">
              {/* Podium Blocks */}
              <div className="col-12 col-lg-7 d-flex align-items-end justify-content-center px-3" style={{ minHeight: '380px', marginBottom: '20px' }}>
                <div className="d-flex align-items-end justify-content-center gap-3 w-100">
                  
                  {/* 2nd Place */}
                  <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '160px' }}>
                    {leaderboard[1] && (
                      <div className="text-center mb-2 animate-fade-in">
                        <div className="fw-bold text-truncate" style={{ fontSize: '16px', maxWidth: '140px', color: '#fff' }}>
                          {typeof leaderboard[1] === 'object' ? (leaderboard[1].name || leaderboard[1].Name) : leaderboard[1]}
                        </div>
                        <div className="small fw-semibold" style={{ color: colors.cyan }}>
                          {leaderboard[1].total_accumulated_marks} pts
                        </div>
                      </div>
                    )}
                    <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
                      height: '160px', 
                      background: 'linear-gradient(180deg, #1e1f4b 0%, rgba(30,31,75,0.4) 100%)', 
                      border: '2px solid rgba(255,255,255,0.1)', 
                      borderRadius: '16px 16px 0 0'
                    }}>
                      <span className="fw-extrabold" style={{ fontSize: '48px', color: '#a0aec0', opacity: 0.8 }}>2</span>
                    </div>
                  </div>

                  {/* 1st Place */}
                  <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '180px' }}>
                    {leaderboard[0] && (
                      <div className="text-center mb-2 animate-bounce">
                        <div style={{ fontSize: '28px', marginBottom: '-5px' }}>👑</div>
                        <div className="fw-bold text-truncate" style={{ fontSize: '18px', maxWidth: '160px', color: '#fff' }}>
                          {typeof leaderboard[0] === 'object' ? (leaderboard[0].name || leaderboard[0].Name) : leaderboard[0]}
                        </div>
                        <div className="fw-bold" style={{ color: colors.orange }}>
                          {leaderboard[0].total_accumulated_marks} pts
                        </div>
                      </div>
                    )}
                    <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
                      height: '220px', 
                      background: `linear-gradient(180deg, ${colors.orange} 0%, rgba(243,80,24,0.2) 100%)`, 
                      border: `2px solid ${colors.orange}`, 
                      borderRadius: '16px 16px 0 0'
                    }}>
                      <span className="fw-extrabold text-white" style={{ fontSize: '64px' }}>1</span>
                    </div>
                  </div>

                  {/* 3rd Place */}
                  <div className="d-flex flex-column align-items-center flex-grow-1" style={{ maxWidth: '140px' }}>
                    {leaderboard[2] && (
                      <div className="text-center mb-2 animate-fade-in">
                        <div className="fw-bold text-truncate" style={{ fontSize: '14px', maxWidth: '120px', color: '#fff' }}>
                          {typeof leaderboard[2] === 'object' ? (leaderboard[2].name || leaderboard[2].Name) : leaderboard[2]}
                        </div>
                        <div className="small fw-semibold" style={{ color: colors.cyan }}>
                          {leaderboard[2].total_accumulated_marks} pts
                        </div>
                      </div>
                    )}
                    <div className="w-100 d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ 
                      height: '120px', 
                      background: 'linear-gradient(180deg, #16173a 0%, rgba(226,23,58,0.3) 100%)', 
                      border: '2px solid rgba(255,255,255,0.06)', 
                      borderRadius: '16px 16px 0 0'
                    }}>
                      <span className="fw-extrabold" style={{ fontSize: '36px', color: '#ed8936', opacity: 0.7 }}>3</span>
                    </div>
                  </div>

                </div>
              </div>

              {/* Participant Standings List */}
              <div className="col-12 col-lg-5">
                <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', padding: '25px', borderRadius: '24px', maxHeight: '420px', overflowY: 'auto' }}>
                  <h4 className="fw-bold mb-3 border-bottom border-secondary pb-2" style={{ fontSize: '16px', color: '#fff' }}>
                    All Participant Standings
                  </h4>
                  
                  {leaderboard.length === 0 ? (
                    <p className="text-muted small italic m-0">No score metrics available.</p>
                  ) : (
                    <div className="d-flex flex-column gap-2">
                      {leaderboard.map((player, index) => {
                        const name = typeof player === 'object' ? (player.name || player.Name) : player;
                        const score = player.total_accumulated_marks || 0;
                        return (
                          <div key={index} className="d-flex justify-content-between align-items-center px-3 py-2.5 rounded-3" style={{ background: index < 3 ? 'rgba(99,222,204,0.05)' : 'rgba(255,255,255,0.02)', border: index < 3 ? `1px solid rgba(99,222,204,0.15)` : '1px solid transparent' }}>
                            <div className="d-flex align-items-center gap-2">
                              <span className="fw-bold small" style={{ minWidth: '24px' }}>#{index + 1}</span>
                              <span className="fw-semibold" style={{ color: index === 0 ? colors.cyan : '#fff' }}>👤 {name}</span>
                            </div>
                            <span className="fw-bold text-end" style={{ color: index === 0 ? colors.orange : colors.cyan }}>
                              {score} <span className="small  fw-normal" style={{ fontSize: '11px' }}>pts</span>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="text-center mt-5">
              <button 
                onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
                className="btn btn-lg px-5 fw-bold py-3 text-white" 
                style={{ background: `linear-gradient(135deg, #ff6b6b, ${premiumColors[0]})`, border: 'none', borderRadius: '16px', boxShadow: '0 10px 25px rgba(226,27,60,0.2)' }}
              >
                Exit Match Arena
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default HostLiveRoom;